module.exports = __webpack_public_path__ + "static/media/Plus.08800cbd.png";